const RoutePaths = {
    HOME: { path: '/', index: 0, scroll: false },
    GERADORES: { path: '/geradores', index: 1, scroll: false },
    SERVICOS: { path: '/servicos', index: 1, scroll: true },
    COBERTURA: { path: '/cobertura', index: 2, scroll: false },
    CONTATO: { path: '/contato', index: 3, scroll: false },
    QUEMSOMOS : { path: '/quem-somos', index: 4, scroll: false },
};

export default RoutePaths;
